import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAssistant } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

export const sendDoctorAssistantMessage = createAsyncThunk(
    "doctorAssistant/sendDoctorAssistantMessage",
    async ({ text, context }, { rejectWithValue }) => {
        try {
            const { data } = await axiosAssistant.post(ENDPOINTS.ASSISTANT.DOCTOR_CHAT, {
                message: text,
                context,
            });

            return {
                message: data?.message ?? "",
                links: Array.isArray(data?.links) ? data.links : [],
                action: data?.action ?? null,
                data: data?.data ?? {},
                ui: data?.ui ?? null,
                meta: data?.meta ?? null,
            };
        } catch (err) {
            return rejectWithValue({
                message: err?.response?.data?.message || err.message,
                status: err?.response?.status,
                data: err?.response?.data,
            });
        }
    }
);
